var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFolderOpenOutline16(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "folder-open-outline-16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "color",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5 1C0.671573 1 0 1.67157 0 2.5V13.5C0 14.3284 0.671573 15 1.5 15H1.80278H7.25H11.5729C12.1411 15 12.6605 14.679 12.9146 14.1708L15.4146 9.17082C15.9133 8.17347 15.188 7 14.0729 7H13V4.5C13 3.67157 12.3284 3 11.5 3H7.5L6.45 1.6C6.16672 1.22229 5.72214 1 5.25 1H1.5ZM11.5 7V5C11.5 4.72386 11.2761 4.5 11 4.5H7.25C7.09262 4.5 6.94443 4.4259 6.85 4.3L5.65 2.7C5.55557 2.5741 5.40738 2.5 5.25 2.5H2C1.72386 2.5 1.5 2.72386 1.5 3V12.6875L4.56071 7.71385C4.8337 7.27023 5.3173 7 5.83819 7H11.5ZM7.26273 13.5001C7.2585 13.5 7.25425 13.5 7.25 13.5H3.87255C3.49017 13.4924 3.25629 13.0731 3.45442 12.7429L5.85442 8.74286C5.94478 8.59226 6.10753 8.50011 6.28316 8.50011H13.1911C13.5627 8.50011 13.8045 8.89126 13.6383 9.22371L11.6383 13.2237C11.5536 13.3931 11.3804 13.5001 11.1911 13.5001H7.26273Z",
    fill: "#7B868C"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderOpenOutline16);
export default __webpack_public_path__ + "static/media/folder_open_outline_16.f847f5a2eff3b4240bb2a1887bfb2f29.svg";
export { ForwardRef as ReactComponent };